import React, { useState, useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

const JobPositionEditModal = (props) => {
    const { modal, setModal } = props;
    const { values, setFieldValue } = useFormikContext();
    const [selectedPosition, setSelectedPosition] = useState(values?.position);

    useEffect(() => {
        if (values?.position) {
            setSelectedPosition(values?.position);
        }
    }, [values?.position]);

    const handleRadioClick = (e) => {
        setSelectedPosition(e.target.value);
    };

    const handleSubmit = () => {
        setFieldValue('position', selectedPosition);
        setModal(false);
    };

    return (
        <Modal isOpen={modal} toggle={() => setModal(!modal)} className="nex-model-v2 modal-dialog-scrollable modal-dialog-centered">
            <ModalHeader toggle={() => setModal(!modal)}>Edit Job Position</ModalHeader>
            <ModalBody>
                <div className="form-group gap-md">
                    <h2 className='nex-text-lg text-black'>Select the type of position you are hiring for</h2>
                    <div className="nex-inline-radio-group">
                        <div className="item">
                            <Field
                                type="radio"
                                name="positionType"
                                value="Full Time"
                                checked={selectedPosition === "Full Time" || selectedPosition === "FULL_TIME"}
                                onClick={handleRadioClick}
                            /> Full Time
                        </div>
                        <div className="item">
                            <Field
                                type="radio"
                                name="positionType"
                                value="Part Time"
                                checked={selectedPosition === "Part Time" || selectedPosition === "PART_TIME"}
                                onClick={handleRadioClick}
                            /> Part Time
                        </div>
                        <div className="item">
                            <Field
                                type="radio"
                                name="positionType"
                                value="Flexible Time"
                                checked={selectedPosition === "Flexible Time" || selectedPosition === "FLEXIBLE_TIME"}
                                onClick={handleRadioClick}
                            /> Flexible-Time
                        </div>
                        <div className="item">
                            <Field
                                type="radio"
                                name="positionType"
                                value="Consultant"
                                checked={selectedPosition === "Consultant" || selectedPosition === "CONSULTANT"}
                                onClick={handleRadioClick}
                            /> Consultant
                        </div>
                    </div>
                </div>
                <div className="form-group nex-action-flex">
                    <Button
                        id="nex-pa-about-submit-btn"
                        className="nex-btn-primary mr-2"
                        color="primary"
                        onClick={handleSubmit}
                    >
                        Save
                    </Button>
                    <Button
                        id="nex-pa-about-cancel-btn"
                        onClick={() => setModal(false)}
                        className="nex-btn-primary-outline"
                        color="primary"
                    >
                        Cancel
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default JobPositionEditModal;
